import React, { useState, useEffect } from "react";
import { Heading, IconView, TableWarpper, Text } from "../styledConstants";
import { Link, useParams } from "react-router-dom";
import Request from "../../utils/Request";
import Config from "../../utils/config";
import { Wrapper } from "../../Pages/MerchantDetail/style";
const roleConfig = {
  individual: "ROLE_INDIVIDUAL_MERCHANT_USER",
  business: "ROLE_BUSINESS_MERCHANT_USER",
  customer: "ROLE_INDIVIDUAL_MERCHANT_USER",
};

export default function BeneUserList() {
  const [userDetails, setUserDetails] = useState([]);
  const { accountNumber, ifscCode } = useParams();

  useEffect(() => {
    if (accountNumber && ifscCode) {
      fetchUserDetails();
    }
  }, [accountNumber, ifscCode]);

  const fetchUserDetails = () => {
    const successHandler = (res) => {
      if (res && res.data) {
        // Convert object of users to array for table rendering
        const usersArray = Object.keys(res.data).map((userId) => ({
          userId,
          ...res.data[userId],
        }));
        setUserDetails(usersArray);
      }
    };
    const errorHandler = () => {};
    const api = new Request("", successHandler, errorHandler, false);
    const param = {
      accountNumber,
      ifscCode,
    };
    return api.post(`${Config.apis.admin.USER_DETAILS}`, param);
  };

  return (
    <div className="mt32">
      <Heading size="xxxl">User List</Heading>

      <div className="mt50">
        <TableWarpper className="mt24">
          <table className="table">
            <thead>
              <tr>
                <th className="text-left">
                  <Text size="rg" fw="medium">
                    Name
                  </Text>
                </th>
                <th className="text-left">
                  <Text size="rg" fw="medium">
                    Mobile Number
                  </Text>
                </th>
                <th className="text-left">
                  <Text size="rg" fw="medium">
                    KYC Status
                  </Text>
                </th>
                <th className="text-left">
                  <Text size="rg" fw="medium">
                    Org Code
                  </Text>
                </th>
                <th className="text-left">
                  <Text size="rg" fw="medium">
                    Action
                  </Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {userDetails.length ? (
                userDetails.map((user, index) => (
                  <tr key={index}>
                    <td>
                      <Text size="xsm" color="color1">
                        {user?.firstName} {user?.lastName ? user.lastName : ""}
                      </Text>
                    </td>
                    <td>
                      <Text size="xsm" color="color1">
                        {user?.mobile}
                      </Text>
                    </td>
                    <td>
                      <Text size="xsm" color={user?.isFullKycDone ? "color10" : "color11"}>
                        {user?.isFullKycDone ? "FULL KYC" : "MIN KYC"}
                      </Text>
                    </td>
                    <td>
                      <Text size="xsm" color="color1">
                        {user?.orgCode}
                      </Text>
                    </td>
                    <td>
                      <Link
                        to={`/merchant-detail/${user?.userId}/${Object.keys(roleConfig).find(
                          (key) => roleConfig[key] === user?.userType,
                        )}`}
                      >
                        <IconView />
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No record found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </TableWarpper>
      </div>
    </div>
  );
}
